import React, { useContext } from 'react';
import { Image, Nav } from 'react-bootstrap';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import { FaUser } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../contexts/AuthProvider/AuthProvider';


const Header = () => {
    const {user, logOut} = useContext(AuthContext);

    const handleLogOut = ()=>{
        logOut()
        .then( ()=> {})
        .catch(error => console.error(error))
    }
    return (
        <>
        <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
            <Container>
            <Navbar.Brand href="#home">
                <img
                alt=""
                src="/jse.png"
                width="40"
                height="40"
                className="d-inline-block align-top"
                />{' '}
                Javascript Enthusiasts
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="responsive-navbar-nav" />
            <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className='w-100'>
            <div className="ms-5 px-3 text-white">
                <Link className='mx-2 text-white text-decoration-none' to={'/'}>Home</Link>
                <Link className='mx-2 text-white text-decoration-none' to={'/courses'}>Courses</Link>
                <Link className='mx-2 text-white text-decoration-none' to={'/faq'}>FAQ</Link>
                <Link className='mx-2 text-white text-decoration-none' to={'/blog'}>Blog</Link>
                
                {user ?
                <>
                <Link className='mx-2 text-decoration-none'>{user?.photoURL ?
                                <Image
                                    style={{ height: '30px' }}
                                    roundedCircle
                                    src={user?.photoURL}>
                                </Image>
                                : <FaUser></FaUser>
                            } {user?.displayName}</Link>
                            <button onClick={logOut}>Logout</button>
                </>
                : <><Link className='mx-2 text-white text-decoration-none' to={'/login'}>Log In</Link>
                <Link className='mx-2 text-white text-decoration-none' to={'/register'}>Register</Link></>
                }
            </div>
            </Nav>
            </Navbar.Collapse>
            </Container>
        </Navbar>
        </>
    );
};

export default Header;